<template>
    <v-container style="padding-top: 80px">
        <v-card class="" tile>
            <v-img src="https://www.ausa.com.mx/img/fondo-numeralia.png" style="height: 35vh;">
                <v-row align="center" class="mt-2">
                    <v-col cols="12" md="6" style="display: grid; place-items: center;">
                        <v-avatar class="profile" color="grey" size="154">
                            <img :src="perfil.usfotonew ? perfil.usfotonew : 'https://www.ausa.com.mx/img/images/perfil.png'"
                                alt="perfil" />
                        </v-avatar>
                    </v-col>
                    <v-col cols="12" md="6" class="datosStyle">
                        <v-list-item color="rgba(0, 0, 0, .4)">
                            <v-list-item-content>
                                <v-list-item-title style="font-weight: bold; font-size: x-large;">{{ perfil.usnom }}
                                </v-list-item-title>
                                <v-list-item-subtitle>{{ perfil.pudescripcion }}</v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>
                    </v-col>
                </v-row>
            </v-img>
            <v-card-text>
                <v-row align="center" v-if="!permisollamadas">
                    <v-col cols="12" md="6" style="display: grid; place-items: center;">
                        <v-btn color="#536DFE" style="color:white" @click="RestablecerContrasenia()"
                               :disabled="perfil.btnpassword == 1 ? true : false" :loading="cargar">
                            Restablecer contraseña
                        </v-btn>
                    </v-col>
                    <v-col cols="12" md="6" style="display: grid; place-items: center;">
                        <v-btn color="#3CD4A0" style="color:white" @click="RestablecerFirma()"
                               :disabled="perfil.btnfirma == 1 ? true : false" :loading="cargar">
                            Restablecer firma electrónica
                        </v-btn>
                    </v-col>
                </v-row>
                <v-row align="center" v-if="permisollamadas">
                    <v-col cols="12" md="4" style="display: grid; place-items: center;">
                        <v-btn color="#536DFE" style="color:white" @click="RestablecerContrasenia()"
                               :disabled="perfil.btnpassword == 1 ? true : false" :loading="cargar">
                            Restablecer contraseña
                        </v-btn>
                    </v-col>
                    <v-col cols="12" md="4" style="display: grid; place-items: center;">
                        <v-btn color="#3CD4A0" style="color:white" @click="RestablecerFirma()"
                               :disabled="perfil.btnfirma == 1 ? true : false" :loading="cargar">
                            Restablecer firma electrónica
                        </v-btn>
                    </v-col>
                    <v-col cols="12" md="4" style="display: grid; place-items: center;">
                        <v-btn color="#fecd3e" style="color:white" @click="CambiarTipoLlamada()"
                                :loading="cargar">
                            Cambiar Tipo Llamada
                        </v-btn>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
        <RestablecerFirma v-if="firma" @BtnCancelar="opcCancelar"></RestablecerFirma>
        <RestablecerContrasenia v-if="password" @BtnCancelar="opcCancelar"></RestablecerContrasenia>
        <CambiarTipoLlamada v-if="llamada" @BtnCancelar="opcCancelar" :ustipollamada="perfil.ustipollamada" ></CambiarTipoLlamada>
    </v-container>
</template>

<script>
import PerfilServ from '@/services/main/perfil.service.js';
import RestablecerFirma from "@/components/pages/main/Perfil/RestablecerFirma.vue";
import RestablecerContrasenia from "@/components/pages/main/Perfil/RestablecerContrasenia.vue"
import CambiarTipoLlamada from "@/components/pages/main/Perfil/CambiarTipoLlamada.vue"
    import MetodosGenerales from '@/utils/metodosgenerales.vue.js';
    import { mapState } from 'vuex';

export default {
    components: {
        RestablecerFirma, RestablecerContrasenia, CambiarTipoLlamada
    },
    data() {
        return {
            perfil: [],
            firma: false,
            password: false,
            llamada: false,
            cargar: true,
            permisollamadas: false
        }
        },
        computed: {
            ...mapState([
                "domain",
                "informationPage",
                "paginacion",
                "permission",
                "user"
            ]),
        },
    async beforeMount() {
        this.perfil = await PerfilServ.DatosPerfil();
        this.cargar = false;
    },
        async mounted() {
            await MetodosGenerales.verificarPermisoSolo(this.domain.domainNameForApi, "VerificarPermiso", '401').then(response => {
                if (response.data.length > 0) {
                    this.permisollamadas = true;
                }
            });

        let changeTime = window.sessionStorage.getItem("CambioContraseña");
        if (changeTime == 0 || changeTime == -1) { this.RestablecerContrasenia() }
    },
    methods: {
        async RestablecerFirma() {
            this.firma = true;
            this.password = false;
            this.llamada = false;
        },
        async RestablecerContrasenia() {
            this.password = true;
            this.firma = false;
            this.llamada = false;
        },
        async CambiarTipoLlamada() {
            this.password = false;
            this.firma = false;
            this.llamada = true;
        },
        async opcCancelar() {
            this.firma = false;
            this.password = false;
            this.llamada = false;
            this.perfil = await PerfilServ.DatosPerfil();
            
        },

    }
}
</script>

<style>
.datosStyle {
    display: grid;
    place-items: center;
    text-align: center;
}
</style>